import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import * as settings from '../settings';

export default function PropertyManagement({ isMobile }) {
    return (
        <div className="bg-light">
            {/* Hero Section */}
            <div
                className="bg-dark text-light d-flex align-items-center"
                style={{
                    minHeight: '60vh',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${settings.SITEURL}/hero-bg.jpg)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <h1 className="display-4 fw-bold mb-4">Professional Property Management</h1>
                            <p className="lead fs-3">Protecting your investment, maximizing your returns.</p>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* About Section */}
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col lg={10} className="text-center">
                        <h2 className="fw-bold mb-4">About Our Property Management</h2>
                        <p className="lead text-muted">
                            We offer 24/7 reliable property management services across Chicagoland, designed to give you peace of mind. Our philosophy is simple: we treat your property as if it were our own. By combining proactive maintenance, rigorous tenant screening, and financial transparency, we maximize your ROI while minimizing the stress of ownership. Whether you own a single condo or a multi-unit complex, our dedicated team ensures your assets are protected and profitable.
                        </p>
                    </Col>
                </Row>
            </Container>

            {/* Services Offered */}
            <div className="bg-white py-5">
                <Container>
                    <h2 className="fw-bold text-center mb-5">Services We Offer</h2>
                    <Row>
                        <Col md={4} className="mb-4">
                            <Card className="h-100 border-0 shadow-sm custom-hover-card">
                                <Card.Body className="text-center p-4">
                                    <div className="text-primary mb-3">
                                        <i className="bi bi-clock-history fs-1"></i> {/* Placeholder for icon */}
                                    </div>
                                    <Card.Title className="fw-bold">24/7 Management</Card.Title>
                                    <Card.Text>
                                        We monitor your property around the clock. Our emergency response team is always ready to handle urgent issues, and our online portal gives you real-time access to financial reports and maintenance requests.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4">
                            <Card className="h-100 border-0 shadow-sm custom-hover-card">
                                <Card.Body className="text-center p-4">
                                    <div className="text-primary mb-3">
                                        <i className="bi bi-people fs-1"></i> {/* Placeholder for icon */}
                                    </div>
                                    <Card.Title className="fw-bold">Reliable Vendors</Card.Title>
                                    <Card.Text>
                                        We have curated a network of fully licensed and insured vendors who provide top-tier workmanship at negotiated rates. You get quality repairs without the premium price tag.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4">
                            <Card className="h-100 border-0 shadow-sm custom-hover-card">
                                <Card.Body className="text-center p-4">
                                    <div className="text-primary mb-3">
                                        <i className="bi bi-graph-up fs-1"></i> {/* Placeholder for icon */}
                                    </div>
                                    <Card.Title className="fw-bold">Distressed Properties</Card.Title>
                                    <Card.Text>
                                        We specialize in bringing distressed properties back to life. From securing vacant homes to managing complex probate estates, we handle the unique challenges that scare others away.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Specialization Section */}
            <Container className="py-5">
                <Row className="align-items-center">
                    <Col lg={6} className="mb-4 mb-lg-0">
                        <img
                            src={`${process.env.PUBLIC_URL}/svg/repairs.svg`}
                            alt="Property Maintenance"
                            className="img-fluid rounded"
                            style={{ maxHeight: '400px', width: '100%', objectFit: 'contain' }}
                        />
                    </Col>
                    <Col lg={6}>
                        <h2 className="fw-bold mb-4">Specialized Care for Distressed Properties</h2>
                        <ul className="list-unstyled">
                            <li className="mb-3 d-flex align-items-start">
                                <span className="me-3 text-primary">✔</span>
                                <div>
                                    <strong>Probate Estates:</strong> We understand the sensitivity and legal complexities of probate. We work closely with executors and attorneys to manage, clear out, and prepare properties for sale or lease.
                                </div>
                            </li>
                            <li className="mb-3 d-flex align-items-start">
                                <span className="me-3 text-primary">✔</span>
                                <div>
                                    <strong>Vacant Property Security:</strong> Vacant homes are vulnerable. We implement regular inspections, secure entry points, and maintain curb appeal to deter vandalism and preserve value.
                                </div>
                            </li>
                            <li className="mb-3 d-flex align-items-start">
                                <span className="me-3 text-primary">✔</span>
                                <div>
                                    <strong>Rehabilitation Management:</strong> From minor cosmetic fixes to major structural repairs, we oversee the entire rehabilitation process to get your property market-ready quickly and cost-effectively.
                                </div>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>

            {/* Areas We Service */}
            <div className="bg-dark text-light py-5">
                <Container className="text-center">
                    <h2 className="fw-bold mb-4">Areas We Service</h2>
                    <p className="lead mb-4">Proudly serving Chicago and the entire Chicagoland area.</p>
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <p className="text-white-50">
                                We cover all neighborhoods in the city and surrounding suburbs. Contact us to see if your property is within our service range.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}
